import React from "react";
import Select from "react-select";

const symptomsList = [
  "Decreased duration of intercourse",
  "Reduced erection hardness",
  "Semen has become watery",
  "Decrease in semen volume",
  "Lack of sexual desire",
  "Increased fatigue",
  "Body aches",
  "Burning sensation or heat in the genital area",
  "Lumps felt in semen",
  "Blood present in semen",
  "Foul or decayed smell from semen",
  "Pus discharge in semen",
  "Pain during or after intercourse",
  "Burning sensation in the genitals",
  "Rashes or eruptions on the genitals",
  "Cracks or fissures on the genitals",
  "None of the above",
  "Other",
];

const metallicColorOptions = [
  { value: "White", label: "White" },
  { value: "Gray", label: "Gray" },
  { value: "Yellow", label: "Yellow" },
];

const symptomsOptions = symptomsList.map((symptom) => ({
  value: symptom,
  label: symptom,
}));

const MaleFormFields = ({ formData, setFormData, errors = {} }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prev) => ({ ...prev, [name]: selectedOption }));
  };

  return (
    <div className="male-form-fields">
      {/* Date */}
      <div className="mb-3">
        <label className="form-label">Date<span className="text-danger">*</span></label>
        <input
          type="date"
          className="form-control"
          name="date"
          value={formData.date}
          onChange={handleChange}
          max={new Date().toISOString().split("T")[0]}
          required
        />
        {errors.date && <small className="text-danger">{errors.date}</small>}
      </div>

      {/* Symptoms */}
      <div className="mb-3">
        <label className="form-label">Symptoms during/after intercourse?<span className="text-danger">*</span></label>
        <Select
          isMulti
          name="symptoms"
          value={formData.symptoms}
          onChange={handleSelectChange}
          options={symptomsOptions}
          placeholder="Select symptoms"
          isClearable
          required
        />
        {errors.symptoms && <small className="text-danger">{errors.symptoms}</small>}

        {formData.symptoms?.some((option) => option.value === "Other") && (
          <div className="mt-2">
            <input
              type="text"
              className="form-control"
              placeholder="Please specify other symptom"
              name="otherSymptom"
              value={formData.otherSymptom}
              onChange={handleChange}
            />
            {errors.otherSymptom && (
              <small className="text-danger">{errors.otherSymptom}</small>
            )}
          </div>
        )}
      </div>

      {/* Metallic Color */}
      <div className="mb-3">
        <label className="form-label">Metallic Color<span className="text-danger">*</span></label>
        <Select
          name="metallicColor"
          value={formData.metallicColor}
          onChange={(selected, action) =>
            handleSelectChange(selected, { ...action, name: "metallicColor" })
          }
          options={metallicColorOptions}
          placeholder="Select color"
          isClearable
          required
        />
        {errors.metallicColor && <small className="text-danger">{errors.metallicColor}</small>}
      </div>
    </div>
  );
};

export default MaleFormFields;
